import React, { useState } from "react";
import ProductCard from "../components/ProductCard";
import { productsData } from "../lib/api";

import { Helmet } from "react-helmet-async";

const ProductsPage = () => {
  const [products] = useState(productsData);
  const [filter, setFilter] = useState("All");

  const categories = ["All", ...Array.from(new Set(products.map((p) => p.category)))];
  const visible = filter === "All" ? products : products.filter((p) => p.category === filter);

  return (
    <main data-testid="products-page" className="bg-cream">
      <Helmet>
        <title>Bulk Botanical Product Catalog — Gralon Global India</title>
        <meta name="description" content="Explore our catalog of premium India-origin products: Psyllium Husk, Chia Seeds, Flax Seeds, and Ayurvedic herbs. Lab-verified quality for global importers." />
      </Helmet>
      {/* Hero */}
      <section className="border-b border-line">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-20">
          <div className="label-eyebrow">The Catalog</div>
          <h1 className="font-serif font-light mt-6 text-5xl lg:text-7xl leading-[1.02] tracking-tight text-ink max-w-4xl">
            Premium products,<br />
            <span className="italic text-forest">crafted for global markets.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-ink/75 text-lg leading-relaxed">
            Browse our full export catalog. Each product page includes detailed
            specifications, certifications and a downloadable spec sheet.
          </p>
        </div>
      </section>

      {/* Filter bar */}
      <div className="border-b border-line bg-cream/80 sticky top-20 z-40 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-wrap gap-3">
          {categories.map((c) => (
            <button
              key={c}
              onClick={() => setFilter(c)}
              data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
              className={`px-4 py-2 text-xs tracking-[0.2em] uppercase transition-colors duration-300 border ${
                filter === c
                  ? "bg-forest text-cream border-forest"
                  : "border-line text-ink/70 hover:border-forest/50"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      {/* Grid */}
      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16">
            {visible.map((p, i) => (
              <ProductCard key={p.slug} product={p} index={i} />
            ))}
          </div>
        </div>
      </section>

      {/* SEO Content Section */}
      <section className="py-20 border-t border-line bg-cream-alt">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <h2 className="font-serif text-3xl text-ink">Premium Botanical Exports from India</h2>
          <p className="mt-6 text-ink/70 leading-relaxed">
            As a specialized export house based in Rajasthan, India, Gralon Global serves as a 
            trusted partner for international wellness brands and food importers. Our catalog 
            features the finest <strong>Psyllium Husk</strong>, <strong>Chia Seeds</strong>, 
            <strong>Flax Seeds</strong>, and a curated selection of <strong>Ayurvedic herbs</strong>. 
            Every shipment is supported by lab-verified specifications, NABL-accredited testing, 
            and transparent logistics (FOB, CIF, DDP). We bridge the gap between Indian 
            agricultural heartlands and global markets, ensuring consistency, purity, and 
            traceability in every lot.
          </p>
        </div>
      </section>
    </main>
  );
};

export default ProductsPage;
